import React from 'react'
import CreditCardDropdownV2, { CreditCardDropdownV2Props } from 'src/components/CreditCardDropdownV2/CreditCardDropdownV2'

import style from './UtilityToolbarCreditCardDropdown.style'

interface UtilityToolbarCreditCardDropdownProps {
  creditCardDropdownProps: CreditCardDropdownV2Props
}

const UtilityToolbarCreditCardDropdown: React.FC<UtilityToolbarCreditCardDropdownProps> = ({
  creditCardDropdownProps,
}): React.ReactElement => {
  return (
    <div css={style} className='UtilityToolbarCreditCardDropdown'>
        <CreditCardDropdownV2
          {...creditCardDropdownProps}
        />
    </div>
  )
}

export default UtilityToolbarCreditCardDropdown